"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllDivisions = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var certification_1 = require("../../model/certification");
var service_1 = require("../../../library/base/service");
var getAllDivisions = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(getAllDivisions, _super);
    function getAllDivisions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '完善信息下拉列表';
        _this.code = '101170';
        _this.desc = '完善信息下拉列表';
        _this.requestParams = new certification_1.GetAllDivisionsRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return getAllDivisions;
}(service_1.BaseService));
exports.getAllDivisions = getAllDivisions;
//# sourceMappingURL=getAllDivisions.js.map